module.exports = __webpack_public_path__ + "img/MERCADOTECNIA.f836a016.jpeg";